import React from "react";
import PropTypes from "prop-types";
import {
  classStringBuilder,
  conditionallyAddStyles,
  isSpecial,
} from "../../support/helpers";
import SolidColorIndicator from "./color-indicators/solid";
import OutlineColorIndicator from "./color-indicators/outline";

const propTypes = {
  optionValue: PropTypes.instanceOf(Object).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: "",
};

const EditingOptionAsset = ({ optionValue, className }) => {
  const defaultClasses = [
    "h-12",
    "w-12",
    "md:h-20",
    "md:w-20",
    "flex",
    "justify-center",
    "items-center",
  ];

  const additionalClasses = className.split(" ");

  // Check for special seconds hand
  conditionallyAddStyles(
    isSpecial(optionValue.type),
    additionalClasses,
    "transform rotate-90 md:rotate-0 md:h-full",
    "md:h-20"
  );
  const classes = classStringBuilder(defaultClasses, additionalClasses);

  const switchOptionAsset = () => {
    switch (optionValue.selectionAsset.type) {
      case "color":
        return (
          <SolidColorIndicator colors={optionValue.selectionAsset.colors} />
        );
      case "outline":
        return (
          <OutlineColorIndicator
            backgroundColor={optionValue.selectionAsset.backgroundColor}
            outlineColor={optionValue.selectionAsset.outlineColor}
          />
        );
      default:
        return (
          <img src={optionValue.selectionAsset.asset} alt={optionValue.title} />
        );
    }
  };

  return <div className={classes}>{switchOptionAsset()}</div>;
};

EditingOptionAsset.propTypes = propTypes;

EditingOptionAsset.defaultProps = defaultProps;

export default EditingOptionAsset;
